<div class="container-fluid">
  <!-- motif-row: Main row containing sidebar and main content -->
  <div class="motif-row">
    <div class="motif-col-lg-1 fal">
      <img src="./images/_Sidebar Nav items.png" />
    </div>
    <div
      class="motif-col-lg-11"
      style="width: 94%; background-color: rgba(249, 249, 250, 1)"
    >
      <!-- motif-row: Header section with title and navigation -->
      <div class="motif-row" style="margin-left: 12px">
        <div class="motif-col-lg-12 product-title">
          <img
            src="nav-arrow-left.png"
            class="btn-arrow"
            alt="file"
            (click)="goToAdmin()"
          />
          Products Details - Instruction of {{ _instructName }}
        </div>
        <div
          class="motif-col-lg-12 mt-4 d-flex align-items-center justify-content-between"
        >
          <span>{{ this.versionDetails?.Version }}</span>
          <div>
            <img
              src="edit.png"
              style="cursor: pointer"
              alt="file"
              (click)="openModal()"
            />
            <!--    <img
              src="delete.png"
              class="ms-2"
              alt="file"
              (click)="goToAdmin()"
            /> -->
          </div>
        </div>
        <div
          class="motif-col-lg-12 mt-4 d-flex align-items-center justify-content-between tagwala"
        >
          <div>
            <span style="margin-left: 4px">Tags</span>
            <br />
            <span
              class="tagborder"
              *ngFor="let tag of (versionDetails?.Tags ? versionDetails.Tags.split(',') : [])"
            >
              <img src="tag.png" alt="file" />
              {{ tag }}
            </span>
          </div>
          <motif-toggle-switch
            prelabel="Inactive"
            postlabel="Active"
            name="Default Off Switch"
            [value]="toggleSwitch"
            (change)="toggle()"
          ></motif-toggle-switch>
        </div>
      </div>
      <!-- motif-row: Section for Retriever and step description -->
      <ng-container *ngFor="let step of stepDetails">
        <div class="motif-row mt-4 step-description">
          <div class="motif-col-lg-12 retriver">
            Step {{ step.InstructionStep }} - {{ step.InstructionType }}
          </div>
          <div class="motif-col-lg-12 py-3">
            {{ step.InstructionValue }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<modal-update-instruction
  *ngIf="isModalOpen"
  (close)="isModalOpen = false"
  [instructionDetails]="response"
   title="Edit Version"
></modal-update-instruction>
